import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { PaymentProviders } from '@/constants';
import { CheckoutEvent } from '@/services/analytics/events';

@Component({
    name: 'CmgCheckoutCustomerPayment',
})
export default class CmgCheckoutCustomerPayment extends Vue {
    @Prop({ default: false, type: Boolean })
    isProcessingError!: boolean;

    @Prop({ default: '', type: String })
    errorText!: string;

    get isGuest(): boolean {
        const customer = this.$appStore.state.customer.profile;

        return (customer && customer.isGuest) || false;
    }

    get hasPaymentCards(): boolean {
        return !!this.$appStore.state.customer.wallet.paymentCards.length;
    }

    get hasError(): boolean {
        return this.$appStore.state.checkout.payment.methods.length == 0;
    }

    get hasReachedMaxCreditCards(): boolean {
        return this.$services.customer.isCustomerAtMaxCreditCards(this.$appStore.state.checkout.paymentProvider);
    }

    get hasReachedMaxGiftCards(): boolean {
        return this.$services.customer.isCustomerAtMaxGiftCards();
    }

    get allowGiftCard(): boolean {
        return this.$appStore.state.checkout.paymentProvider != PaymentProviders.Chase && !this.hasReachedMaxGiftCards;
    }

    get canAddCard(): boolean {
        return !this.$appStore.state.checkout.payment.oneTimePaymentCard;
    }

    onClickAddGiftCard(event: any) {
        this.$services.ui.pushEventTargetAsLastSelectedElement(event);
        this.$services.ui.setModalVisibility('addGiftCardModal', true);
        this.$services.analytics.send(new CheckoutEvent('add-gift-card'));
        this.$services.ui.firstFocus();
    }

    onClickAddCreditCard(event: any) {
        this.$services.ui.pushEventTargetAsLastSelectedElement(event);
        this.$services.ui.setModalVisibility('addCreditOrDebitCardModal', true, { providerId: this.$appStore.state.checkout.paymentProvider });
        this.$services.analytics.send(new CheckoutEvent('add-credit-card'));
        this.$services.ui.firstFocus();
    }

    // For Chase payment provider we don't want to display one time payment form on page
    onClickOneTimePayment(event: any) {
        this.$services.ui.pushEventTargetAsLastSelectedElement(event);
        this.$services.ui.setModalVisibility('addCreditOrDebitCardModal', true, { oneTimePaymentUse: true, providerId: this.$appStore.state.checkout.paymentProvider });
        this.$services.analytics.send(new CheckoutEvent('one-time-payment'));
        this.$services.ui.firstFocus();
    }
}
